import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";

/**
 * Banner displayed when the application is in read-only (locked) mode.
 */
@customElement("bab-readonly-banner")
export class BabReadonlyBanner extends LitElement {
  static styles = css`
    :host {
      display: block;
      height: 32px;
      opacity: 1;
      visibility: visible;
      transition: opacity 0.25s ease, visibility 0.25s ease;
    }

    :host(:not([active])) {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }

    .banner-inner {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 14px;
      height: 100%;
      background: var(--bab-banner-bg, #fffbeb);
      border-left: 3px solid var(--bab-banner-border, #fcd34d);
      border-radius: 0 6px 6px 0;
      font-size: 0.8rem;
      color: var(--bab-banner-text, #92400e);
      box-sizing: border-box;
      white-space: nowrap;
    }

    svg {
      flex-shrink: 0;
    }
  `;

  @property({ type: Boolean, reflect: true })
  active = false;

  render() {
    return html`
      <div class="banner-inner">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
        Viewing shared results — toggle Edit to make changes.
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bab-readonly-banner": BabReadonlyBanner;
  }
}
